import { createVar } from '@vanilla-extract/css';
import { lightBlue } from '../palette';
import { themeVars } from '../theme/vars';
import { style, styleVariants } from '../layer.css';

const thumbTranslateChecked = createVar();

export const switchRoot = style({
  border: 0,
  padding: 0,
  outline: 'none',
  backgroundColor: themeVars.selectors.background.idle,
  transition: 'background-color .15s cubic-bezier(0.4, 0.0, 0.2, 1)',
  borderRadius: '9999px',
  position: 'relative',
  cursor: 'pointer',
  ':focus': {
    outline: 'none',
  },
  ':focus-visible': {
    outline: `2px solid ${lightBlue[500]}`,
    outlineOffset: '1px',
  },
  selectors: {
    "&[data-state='checked']": {
      backgroundColor: themeVars.selectors.background.filled,
    },
    '&[data-disabled]': {
      backgroundColor: themeVars.selectors.disabled.background,
      cursor: 'not-allowed',
      border: `1px solid ${themeVars.selectors.disabled.border}`,
    },
  },
});

export const switchRootSizes = styleVariants({
  md: { minWidth: 42, height: 24 },
  sm: { minWidth: 24, height: 14 },
});

export type SwitchSize = keyof typeof switchRootSizes;

export const switchThumb = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: themeVars.selectors.foreground.filled,
  borderRadius: '9999px',
  transition: 'transform .15s cubic-bezier(0.4, 0.0, 0.2, 1)',
  transform: 'translateX(2px)',
  willChange: 'transform',
  selectors: {
    '&[data-state="unchecked"]': {
      color: themeVars.selectors.foreground.disabled,
    },
    "&[data-state='checked']": {
      transform: `translateX(${thumbTranslateChecked})`,
      color: themeVars.selectors.foreground.primary,
    },
    '&[data-disabled]': {
      backgroundColor: themeVars.selectors.disabled.foreground,
    },
  },
});

export const switchThumbSizes = styleVariants({
  md: {
    width: 20,
    height: 20,
    vars: { [thumbTranslateChecked]: '20px' },
  },
  sm: {
    width: 12,
    height: 12,
    vars: { [thumbTranslateChecked]: '10px' },
  },
});
